// Lightweight GA4 helper utilities.
// This is intended for minimal use in the site to send page views/events to Google Analytics.

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;

export function isGtagReady() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function' && GA_MEASUREMENT_ID;
}

export function isClarityReady() {
  return typeof window !== 'undefined' && typeof window.clarity === 'function' && CLARITY_PROJECT_ID;
}

export function initGtag() {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined') return;
  if (window.gtag) return; // already initialized

  // Load GA library
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line no-inner-declarations
  window.gtag = gtag;

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { page_path: window.location.pathname });
}

export function initClarity() {
  if (!CLARITY_PROJECT_ID || typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.clarity) return;

  window.clarity = window.clarity || function() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  document.head.appendChild(script);
}

export function trackPageView(path) {
  if (!isGtagReady()) return;
  window.gtag('event', 'page_view', {
    page_path: path || window.location.pathname,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!isGtagReady()) return;
  window.gtag('event', eventName, params);
}
